<template>
  <AnalyticsChartLayout
    :chart-info-list="userMsuChartList"
    title="MapleStory Universe"
    :colspan-index="0"
  />
  <AnalyticsChartLayout
    :chart-info-list="userMsnChartList"
    title="MapleStory N"
  />
</template>

<script lang="ts" setup>
import AnalyticsChartLayout from '~/components/@pages/analytics/AnalyticsChartLayout.vue'
import { ANALYTICS_CHART_API } from '~/constants/analytics.constants'

const userMsuChartList = Object.entries(ANALYTICS_CHART_API).filter(([ key, value ]) => {
  return key.includes('user-msu')
})
const userMsnChartList = Object.entries(ANALYTICS_CHART_API).filter(([ key, value ]) => {
  return key.includes('user-msn')
})
</script>

<style lang="scss" scoped>

</style>